// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__L09_g","colBig":"styles_colBig__Fe3bW","colSmall":"styles_colSmall__3qFqV","shopifyNameWrapper":"styles_shopifyNameWrapper__1tIAx"};